"use strict";
// <copyright file="serventias-api.ts" company="Top365">
// Copyright (c) Top365. All rights reserved.
// </copyright>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportUrl = exports.getAppSetup = exports.isAdmin = exports.getUserPermissions = exports.createOnlineMeetingAndUpdateStatus = exports.deleteServentia = exports.getServentia = exports.getExpiredQueues = exports.getEndedQueues = exports.getQueuesHistory = exports.getQueueById = exports.getQueuesStatusCount = exports.cancelCall = exports.terminateCall = exports.createOrUpdateServentia = exports.getMeetingsLast7Days = exports.getIndexedMeetings = exports.getLastRequestsLast7Days = exports.getFilteredMetricsItemData = exports.getMetricsItemData = exports.getAttendancesReportData = exports.getActiveUnidadesData = exports.getMetricsData = exports.getGeneralViewUnidadeData = exports.getGeneralViewData = exports.getMeetingsDataPaged = exports.getMeetingsData = exports.getMeetingItemData = void 0;
var axios_decorator_1 = require("./axios-decorator");
var baseAxiosUrl = window.location.origin;
/**
* Get serventias by ID.
*/
exports.getMeetingItemData = function (ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetMeeting?ancora=" + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url, undefined, false)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get serventias collection from the api.
*/
exports.getMeetingsData = function (filter, secaoJudiciaria, filterView, userPinned) { return __awaiter(void 0, void 0, void 0, function () {
    var meetingRequest, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                meetingRequest = {
                    filter: filter,
                    secaoJudiciaria: secaoJudiciaria,
                    userPinned: userPinned,
                    filterView: filterView,
                };
                url = baseAxiosUrl + "/api/serventias/GetAll?meeting=" + JSON.stringify(meetingRequest);
                return [4 /*yield*/, axios_decorator_1.default.get(url, undefined, false)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get serventias paged collection from the api.
*/
exports.getMeetingsDataPaged = function (offset, limit, filter, sortProperty, sortType, secaoJudiciaria, userPinned, filterView) { return __awaiter(void 0, void 0, void 0, function () {
    var meetingPagedRequest, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                meetingPagedRequest = {
                    offset: offset,
                    limit: limit,
                    filter: filter,
                    orderProperty: sortProperty,
                    orderType: sortType,
                    secaoJudiciaria: secaoJudiciaria,
                    userPinned: userPinned,
                    filterView: filterView,
                };
                url = baseAxiosUrl + "/api/serventias/GetMeetingsPaged?meetingPaged=" + JSON.stringify(meetingPagedRequest);
                return [4 /*yield*/, axios_decorator_1.default.get(url, undefined, false)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//GetGeneralViewData
/**
* Get visão geral atendimentos data.
*/
exports.getGeneralViewData = function (count, ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var params, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = count == 0 ? "" : "?daysCount=" + count;
                if (ancora && count != 0) {
                    params = params + ("&ancora=" + ancora);
                }
                else if (ancora && count == 0) {
                    params = "?ancora=" + ancora;
                }
                url = baseAxiosUrl + "/api/serventias/GetGeneralViewData" + params;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get visão geral atendimentos data - Painel de Atendimento.
*/
exports.getGeneralViewUnidadeData = function (ancora, count) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetGeneralViewUnidadeData?ancora=" + ancora + "&daysCount=" + count;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get total metrics data.
*/
exports.getMetricsData = function (ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ancora = ancora ? "?ancora=" + ancora : "";
                url = baseAxiosUrl + "/api/serventias/GetTotalMetricsData" + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get active unidades data.
*/
exports.getActiveUnidadesData = function (count) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetActiveUnidadesData?daysCount=" + count;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get relatorio de atendimentos data.
*/
exports.getAttendancesReportData = function (count, ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ancora = ancora ? "&ancora=" + ancora : "";
                url = baseAxiosUrl + "/api/serventias/GetAttendancesReportData?daysCount=" + count + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get total metrics item data.
*/
exports.getMetricsItemData = function (ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetTotalItemMetricsData?ancora=" + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get filtered metrics item data.
*/
exports.getFilteredMetricsItemData = function (ancora, count) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetFilteredItemMetricsData?count=" + count + "&ancora=" + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get the total amount of requests over 7 days;
*/
exports.getLastRequestsLast7Days = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetRequestsLast7Days";
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get the total amount of requests over 7 days;
*/
exports.getIndexedMeetings = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetIndexedMeetings";
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get the total amount of active meetings over 7 days;
*/
exports.getMeetingsLast7Days = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetMeetingsLast7Days";
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Create Serventia.
*/
exports.createOrUpdateServentia = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/CreateOrUpdateServentia";
                return [4 /*yield*/, axios_decorator_1.default.put(url, payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Terminate queue call (atendimento).
*/
exports.terminateCall = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/terminatecall?id=" + id;
                return [4 /*yield*/, axios_decorator_1.default.put(url, null)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Cancel queue call (atendimento).
*/
exports.cancelCall = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/cancelcall?id=" + id;
                return [4 /*yield*/, axios_decorator_1.default.put(url, null)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get queues status count
*/
exports.getQueuesStatusCount = function (ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/getqueuesstatuscount?ancora=" + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get queue by id.
*/
exports.getQueueById = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/getqueuebyid?id=" + id;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get queues history
*/
exports.getQueuesHistory = function (queueId) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/getqueuehistory?queueId=" + queueId;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get ended queues.
*/
exports.getEndedQueues = function (ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/getendedqueues?ancora=" + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get expired queues.
*/
exports.getExpiredQueues = function (ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/getexpiredqueues?ancora=" + ancora;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get Serventia by Id.
*/
exports.getServentia = function (serventiaId) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetServentiaById/?serventiaId=" + serventiaId;
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Delete Serventia by Id.
*/
exports.deleteServentia = function (serventiaId) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/DeleteServentiaById/?serventiaId=" + serventiaId;
                return [4 /*yield*/, axios_decorator_1.default.put(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// Create online meeting and update status
exports.createOnlineMeetingAndUpdateStatus = function (queueId, ancora) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + ("/api/serventias/CreateOnlineMeetingAndUpdateStatus?meetingQueueId=" + queueId + "&ancora=" + ancora);
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// Get user permissions
exports.getUserPermissions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetUserRole";
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get Admin UPN.
*/
exports.isAdmin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/IsAdmin";
                return [4 /*yield*/, axios_decorator_1.default.getAdmin(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get app setup config.
*/
exports.getAppSetup = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetAppSetup";
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
* Get PowerBI report url.
*/
exports.getReportUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseAxiosUrl + "/api/serventias/GetReportUrl";
                return [4 /*yield*/, axios_decorator_1.default.get(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//# sourceMappingURL=serventias-api.js.map